import { getLanguage } from './get-language.js';
export function createBinderV3(options) {
    const listeners = new Set();
    const { languageTag, marketId } = options.locale;
    let locale = {
        language: getLanguage(languageTag),
        languageTag,
        marketId,
    };
    options.subscribe((newLocale) => {
        locale = newLocale;
        for (const listener of listeners) {
            listener(locale);
        }
    });
    return () => ({
        featureService: {
            getLocale: () => locale,
            subscribe: (listener) => {
                listeners.add(listener);
                return () => {
                    listeners.delete(listener);
                };
            },
        },
    });
}
//# sourceMappingURL=create-binder-v3.js.map